// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AccountLink_wrapper__Db8kS","text":"AccountLink_text__fh98S","image":"AccountLink_image___M1H0"};